import z from 'zod';
export const UrlSchema = z.string().regex(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, "Not a valid url format, must follow http(s)://{domain}.{end}");